import { ReactComponent as HomeIcon } from '../../assets/images/global-icons/home_ic.svg';
import { ReactComponent as ConnectionsIcon } from '../../assets/images/global-icons/connections_ic.svg';
import { ReactComponent as DetailsIcon } from '../../assets/images/global-icons/how_ic.svg';
import { ReactComponent as ContactsIcon } from '../../assets/images/global-icons/email_ic.svg';
import { ReactComponent as ProfileIcon } from '../../assets/images/global-icons/verified_ic.svg';
import { ReactComponent as NewsIcon } from '../../assets/images/global-icons/speaker_ic.svg';

const navs = [
  {
    id: 1,
    link: '/',
    Icon: HomeIcon,
    name: 'home',
    className: ''
  },

  {
    id: 2,
    link: '/crews',
    Icon: ConnectionsIcon,
    name: 'crews',
    className: ''
  },
  {
    id: 3,
    link: '/news',
    Icon: NewsIcon,
    name: 'news',
    className: ''
  },
  {
    id: 4,
    link: '',
    Icon: DetailsIcon,
    name: 'details',
    className: '',
    children: [
      { id: 41, link: '/details/about', Icon: DetailsIcon, name: 'about', className: '' },
      { id: 42, link: '/details/rating', Icon: DetailsIcon, name: 'rating', className: '' }
    ]
  },
  {
    id: 5,
    link: '/contacts',
    Icon: ContactsIcon,
    name: 'contacts',
    className: ''
  },
  {
    id: 6,
    link: '/profile',
    Icon: ProfileIcon,
    name: 'myProfile',
    className: ''
  }
];

export default navs;
